import { flow } from '@hcr/utils'

import { createGuestsString } from './createGuestsString'
import { createSingleTicketsGuests } from './createSingleTicketsGuests'

export const createSingleTicketsGuestsString = flow(createSingleTicketsGuests, createGuestsString)
